<template>
  <v-dialog :value="dialog" width="500" persistent>
    <video v-if="mediaRecorderStatus === 'recording'" muted autoplay :controls="false" :srcObject.prop="recordMediaStream"/>
    <video v-else-if="mediaRecorderStatus === 'inactive' && recordFile" :src="$getFileUrl(recordFile)" controls/>
    <ChatInputField v-if="dialog" :chatItem="chatItem"/>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import ChatInputField from 'components/chat/ChatInputField'
export default {
  name: 'ChatModalRecordVideo',
  components: {
    ChatInputField,
  },
  data() {
    return {}
  },
  props: {
    chatTranslations: Object,
    chatItem: Object
  },
  computed: {
    ...mapState('record', [
      'recordFile',
      'recordMediaStream',
      'mediaRecorderStatus',
      'mediaRecorderTimer',
      'maxRecordingTime',
      'recordType',
    ]),
    dialog() {
      return (
        this.recordType === 'video' && (this.mediaRecorderStatus !== 'inactive' || this.recordFile)
      )
    },
  },
}
</script>
